<template>
  <div>
    <div class="text item text-center">
      <div class="pull-right" style="margin-bottom: 15px">
        <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button>
      </div>
    </div>
    <el-table :data="dt2table1" height="76vh" class="tb-edit" style="width: 100%" ref="multipleTable"
      :header-cell-style="{ background: '#F5F7FA', textAlign: 'center', color:'#333' }" highlight-current-row>
      <el-table-column label="工厂" width="200" prop="cgcname" align="center">
      </el-table-column>
      <el-table-column label="工厂编号" width="180" prop="cgcode" align="center">
      </el-table-column>
      <el-table-column label="物料名称" width="300" prop="cinvname" align="center">
      </el-table-column>
      <el-table-column label="物料编码" width="180" prop="cinvcode" align="center">
      </el-table-column>
      <el-table-column label="日均需求" width="80" prop="iavestock" align="center">
      </el-table-column>
      <el-table-column label="生产周期" width="180" prop="iproduceday" align="center">
      </el-table-column>
      <el-table-column label="周期配送量" width="180" prop="ipurchaseqty" align="center">
      </el-table-column>
      <el-table-column label="订货点" width="180" prop="ipurchasepoint" align="center">
      </el-table-column>
      <el-table-column label="供应链正常周转库存" width="180" prop="ipurchasepoint" align="center">
      </el-table-column>
      <el-table-column label="正常周转消耗天数" width="180" prop="cNormalConsumDays" align="center">
      </el-table-column>
      <el-table-column v-for="(item, i) in tableHead" :key="i" :label="item.label" :property="item.property" width="240"
        align="center">
        <template slot-scope="scope" v-if="item.child.length == 0">
          {{ scope.row[scope.column.property] }}
        </template>
        <template v-if="item.child.length != 0">
          <el-table-column v-for="(temchild, index) in item.child" :key="index" :label="temchild.label"
            :property="temchild.property" width="240">
          </el-table-column>
        </template>
      </el-table-column>
      <el-table-column label="供应商合计数" width="180" prop="allcvename" align="center">
      </el-table-column>
      <el-table-column label="线边仓库存" width="180" prop="cedgewarehouse" align="center">
      </el-table-column>
      <el-table-column label="仓库库存" width="180" prop="cinventory" align="center">
      </el-table-column>
      <el-table-column label="供应链总库存" width="180" prop="csuminventory" align="center">
      </el-table-column>
      <el-table-column label="实时消耗天数" width="180" prop="csjxhts" align="center">
      </el-table-column>
      <el-table-column label="供应链总库存预警" width="180" prop="cgylzkuyj" align="center">
      </el-table-column>
      <el-table-column prop="cisorder" label="备货数量" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.cisorder>0">
            {{scope.row.cisorder}}
          </span>
          <span v-else>
            0
          </span>
        </template>
      </el-table-column>
      <el-table-column label="当前是否订货" width="180" prop="cisorder" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.cisorder>0">
            是
          </span>
          <span v-else>
            否
          </span>
        </template>
      </el-table-column>
    </el-table>

    <el-table v-show="ecel" :data="dt2table1" id="out-table" class="tb-edit" style="width: 100%" ref="multipleTable"
      :header-cell-style="{ 'text-align': 'center' }">
      <el-table-column label="工厂" width="200" prop="cgcname" align="center">
      </el-table-column>
      <el-table-column label="工厂编号" width="180" prop="cgcode" align="center">
      </el-table-column>
      <el-table-column label="物料名称" width="300" prop="cinvname" align="center">
      </el-table-column>
      <el-table-column label="物料编码" width="180" prop="cinvcode" align="center">
      </el-table-column>
      <el-table-column label="日均需求" width="80" prop="iavestock" align="center">
      </el-table-column>
      <el-table-column label="生产周期" width="180" prop="iproduceday" align="center">
      </el-table-column>
      <el-table-column label="周期配送量" width="180" prop="ipurchaseqty" align="center">
      </el-table-column>
      <el-table-column label="订货点" width="180" prop="ipurchasepoint" align="center">
      </el-table-column>
      <el-table-column label="供应链正常周转库存" width="180" prop="ipurchasepoint" align="center">
      </el-table-column>
      <el-table-column label="正常周转消耗天数" width="180" prop="cNormalConsumDays" align="center">
      </el-table-column>
      <el-table-column v-for="(item, i) in tableHead" :key="i" :label="item.label" :property="item.property" width="240"
        align="center">
        <template slot-scope="scope" v-if="item.child.length == 0">
          {{ scope.row[scope.column.property] }}
        </template>
        <template v-if="item.child.length != 0">
          <el-table-column v-for="(temchild, index) in item.child" :key="index" :label="temchild.label"
            :property="temchild.property" width="240">
          </el-table-column>
        </template>
      </el-table-column>
      <el-table-column label="供应商合计数" width="180" prop="allcvename" align="center">
      </el-table-column>
      <el-table-column label="线边仓库存" width="180" prop="cedgewarehouse" align="center">
      </el-table-column>
      <el-table-column label="仓库库存" width="180" prop="cinventory" align="center">
      </el-table-column>
      <el-table-column label="供应链总库存" width="180" prop="csuminventory" align="center">
      </el-table-column>
      <el-table-column label="实时消耗天数" width="180" prop="csjxhts" align="center">
      </el-table-column>
      <el-table-column label="供应链总库存预警" width="180" prop="cgylzkuyj" align="center">
      </el-table-column>

      <el-table-column prop="cisorder" label="备货数量" width="100" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.cisorder>0">
            {{scope.row.cisorder}}
          </span>
          <span v-else>
            0
          </span>
        </template>
      </el-table-column>
      <el-table-column label="当前是否订货" width="180" prop="cisorder" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.cisorder>0">
            是
          </span>
          <span v-else>
            否
          </span>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
  import FileSaver from "file-saver";
  import XLSX from "xlsx";
  export default {
    props: {
      dt2table1: { type: Array },
      tableHead: { type: Array },
    },
    name: "ruleTable",
    data () {
      return {
        ecel: false,
        data: [],
        multipleSelection: [],
        multiple: [],
        dialogFormVisible: false,
        sdaform: {},
        sdarules: {
          cusername: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        },
        state: "-1",
        digedtable: [],
        sdatable: {},
        dialogcdescribe: false,
      };
    },
    created () {
      setTimeout(() => {
        // console.log(this.dt2table1, "dt2table1");
      }, 2200);
    },
    mounted () { },
    methods: {
      //定义导出Excel表格事件
      exportExcel () {
        /* 从表生成工作簿对象 */
        var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"), {
          raw: true,
        });
        /* 获取二进制字符串作为输出 */
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        try {
          FileSaver.saveAs(
            //Blob 对象表示一个不可变、原始数据的类文件对象。
            //Blob 表示的不一定是JavaScript原生格式的数据。
            //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
            //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
            new Blob([wbout], { type: "application/octet-stream" }),
            //设置导出文件名称
            "物料报表" + Date.now() + ".xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
        return wbout;
      },
    },
  };
</script>